import { render, staticRenderFns } from "./ActivationCodeButtons.vue?vue&type=template&id=070b31e6"
import script from "./ActivationCodeButtons.vue?vue&type=script&lang=js"
export * from "./ActivationCodeButtons.vue?vue&type=script&lang=js"
import style0 from "./ActivationCodeButtons.vue?vue&type=style&index=0&id=070b31e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports